import axiosRequest from "api";
import { payloadHelper } from "helpers/payload-helper";
import { ApiResponse } from "types/api";
import { LoginResponse } from "types/auth";

import {
  ChangePasswordPayload,
  LoginPayload,
  RecoveryFormType,
  RegisterPayload,
  VerifyTokenPayload,
} from "./type";

export const AuthApi = {
  async login(typename: string, payload: LoginPayload) {
    const response = await axiosRequest.post<LoginResponse>(
      "/",
      payloadHelper("MemberLogin", typename, payload)
    );
    return response.data;
  },
  async verifyToken(typename: string, payload: VerifyTokenPayload) {
    const response = await axiosRequest.post<ApiResponse>(
      "/",
      payloadHelper("VerifyToken", typename, payload)
    );
    return response.data;
  },
  async register(typename: string, payload: RegisterPayload) {
    const response = await axiosRequest.post<ApiResponse>(
      "/",
      payloadHelper("MemberRegister", typename, payload)
    );
    return response.data;
  },
  async recovery(typename: string, payload: RecoveryFormType) {
    const response = await axiosRequest.post<ApiResponse>(
      "/",
      payloadHelper("ForgotPassword", typename, payload)
    );
    return response.data;
  },
  async changePassword(typename: string, payload: ChangePasswordPayload) {
    const response = await axiosRequest.post<ApiResponse>(
      "/",
      payloadHelper("ChangePassword", typename, payload)
    );
    return response.data;
  },
};
